import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { UploadReqStepUploadComponent } from './upload-req-step-upload.component';
import { RequisitionSkillsModule } from 'src/app/shared/requisition-skills/requisition-skills.module';

@NgModule({
  declarations: [UploadReqStepUploadComponent],
  imports: [
    CommonModule,
    RequisitionSkillsModule,
    DropzoneModule
  ],
  exports: [UploadReqStepUploadComponent],
  entryComponents: [UploadReqStepUploadComponent]
})
export class UploadReqStepUploadModule { }
